export const TFT_ICON_OVERRIDES = {
  Kaisa: 'KaiSa',
  ChoGath: 'ChoGath',
  DrMundo: 'DrMundo',
  JarvanIV: 'JarvanIV',
  Leblanc: 'Leblanc',
  RekSai: 'RekSai',
  TahmKench: 'TahmKench',
  Velkoz: 'VelKoz',
  Atakhan: 'Atakhan',
  Baron: 'TFT16_BaronNashor_splash_centered_0.TFT_Set16',
  BaronNashor: 'TFT16_BaronNashor_splash_centered_0.TFT_Set16',
  Rift: 'TFT16_RiftHerald_splash_centered_0.TFT_Set16',
  RiftHerald: 'TFT16_RiftHerald_splash_centered_0.TFT_Set16',
  THex: 'TFT16_THex.TFT_Set16',
  Thex: 'TFT16_THex.TFT_Set16'
}

export const TFT_DISPLAY_NAME_OVERRIDES = {
  kaisa: "Kai'Sa",
  chogath: "Cho'Gath",
  drmundo: 'Dr. Mundo',
  jarvaniv: 'Jarvan IV',
  leblanc: 'LeBlanc',
  belveth: "Bel'Veth",
  reksai: "Rek'Sai",
  tahmkench: 'Tahm Kench',
  velkoz: "Vel'Koz",
  baronnashor: 'Baron Nashor',
  riftherald: 'Rift Herald',
  thex: 'T-Hex',
  thx: 'T-Hex',
  kogmaw: 'Kog Maw'
}

export const TFT_TRAIT_NAME_OVERRIDES = {
  TFT16_Sorcerer: 'Arcanist',
  TFT16_KaisaUnique: 'Assimilator',
  TFT16_Explore: 'Ixtal',
  TFT16_AurelionSolUnique: 'Star Forger',
  TFT16_ShyvanaUnique: 'Dragonborn',
  TFT16_Magus: 'Disruptor',
  TFT16_TheBoss: 'The Boss',
  TFT16_Brawler: 'Bruiser',
  TFT16_Rapidfire: 'Quickstricker',
  TFT16_SylasTrait: 'Chainbreaker',
  TFT16_KindredUnique: 'Eternal',
  TFT16_ShadowIsles: 'Shadow Isles',
  TFT16_RuneMage: 'Rune Mage'
}

export const TFT_ITEM_NAME_OVERRIDES = {
  TFT_Item_StatikkShiv: 'Void Staff',
  TFT_Item_GargoyleStoneplate: 'Gargoyle Stoneplate',
  TFT_Item_RapidFireCannon: 'Gold Collector',
  TFT_Item_RabadonsDeathcap: "Rabadon's Deathcap",
  TFT_Item_GuinsoosRageblade: "Guinsoo's Rageblade",
  TFT_Item_ThiefsGloves: "Thief's Gloves",
  TFT_Item_TitansResolve: "Titan's Resolve",
  TFT_Item_JeweledGauntlet: 'Jeweled Gauntlet',
  TFT_Item_IonicSpark: 'Ionic Spark',
  TFT_Item_ArchangelsStaff: "Archangel's Staff",
  TFT_Item_DragonsClaw: "Dragon's Claw",
  TFT_Item_WarmogsArmor: "Warmog's Armor",
  TFT_Item_SteraksGage: "Sterak's Gage",
  TFT_Item_Leviathan: "Nashor's Tooth",
  TFT_Item_ForceOfNature: "Tactician's Crown",
  TFT_Item_SpectralGauntlet: 'Evenshroud',
  TFT_Item_FrozenHeart: "Protector's Vow",
  TFT16_Item_IoniaEmblemItem: 'Ionia Emblem',
  TFT_Item_UnstableConcoction: 'Hand of Justice',
  TFT_Item_MadredsBloodrazor: 'Giant Slayer',
  TFT_Item_PowerGauntlet: "Striker's Flail",
  TFT4_Item_OrnnTheCollector: 'Gold Collector',
  TFT_Item_Artifact_ProwlersClaw: "Prowler's Claw",
  TFT_Item_RedBuff: 'Sunfire Cape',
  TFT_Item_Redemption: 'Spirit Visage'
}
